import '../ui-anchor/ui-anchor.ru.js';
import '../ui-annotation/ui-annotation.ru.js';
import '../ui-assets/ui-assets.ru.js';
import '../ui-autocomplete/ui-autocomplete.ru.js';
import '../ui-breadcrumbs/ui-breadcrumbs.ru.js';
import '../ui-calendar/ui-calendar.ru.js';
import '../ui-chip/ui-chip.ru.js';
import '../ui-comparison-cards/ui-comparison-cards.ru.js';
import '../ui-cookie-consent/ui-cookie-consent.ru.js';
import '../ui-countdown/ui-countdown.ru.js';
import '../ui-curtain/ui-curtain.ru.js';
import '../ui-datepicker/ui-datepicker.ru.js';
import '../ui-daterange/ui-daterange.ru.js';
import '../ui-dialogbubble/ui-dialogbubble.ru.js';
import '../ui-dropdown/ui-dropdown.ru.js';
import '../ui-feedback/ui-feedback.ru.js';
import '../ui-field/ui-field.ru.js';
import '../ui-footer/ui-footer.ru.js';
import '../ui-form/ui-form.ru.js';
import '../ui-message/ui-message.ru.js';
import '../ui-modal/ui-modal.ru.js';
import '../ui-monthpicker/ui-monthpicker.ru.js';
import '../ui-nav/ui-nav.ru.js';
import '../ui-navitem/ui-navitem.ru.js';
import '../ui-navlist/ui-navlist.ru.js';
import '../ui-navtoggle/ui-navtoggle.ru.js';
import '../ui-offer/ui-offer.ru.js';
import '../ui-pagination/ui-pagination.ru.js';
import '../ui-phonefield/ui-phonefield.ru.js';
import '../ui-searchinput/ui-searchinput.ru.js';
import '../ui-signing/ui-signing.ru.js';
import '../ui-skip-to-content/ui-skip-to-content.ru.js';
import '../ui-slider/ui-slider.ru.js';
import '../ui-slides/ui-slides.ru.js';
import '../ui-stepper/ui-stepper.ru.js';
import '../ui-table-cloneable/ui-table-cloneable.ru.js';
import '../ui-table-expandable/ui-table-expandable.ru.js';
import '../ui-table-sortable/ui-table-sortable.ru.js';
import '../ui-tabs/ui-tabs.ru.js';
import '../ui-textcounter/ui-textcounter.ru.js';
import '../ui-timerange/ui-timerange.ru.js';
import '../ui-tooltip/ui-tooltip.ru.js';
import '../ui-upload-item/ui-upload-item.ru.js';
import '../ui-upload/ui-upload.ru.js';
import '../ui-video/ui-video.ru.js';
import '../ui-wizard/ui-wizard.ru.js';
import { Labels } from '../../shared-components/global/labels.js';

Labels.LANGUAGE = 'ru';

window.UI = { ...window.UI, Labels };
